import { Preview } from "@creatomate/preview";
import { ElementSource } from "chq";
import isSubtitleText from "./isSubtitleText";

const removeSubtitlesLanguage = async (
  preview: Preview,
  languages: string[],
  createUndoPoint = true
) => {
  // Remove current subtitles
  const source = preview.getSource();
  await preview.setSource({
    ...source,
    elements: source.elements.filter((element: ElementSource) => (
      !isSubtitleText(element.name) || !languages.some(lang => element.name.includes(`-${lang}-`))
    ))
  }, createUndoPoint);
};

export default removeSubtitlesLanguage;
